import { decodeB64WithEncoding } from '../../../../shared/api/base64/decodeB64WithEncoding.js';
import { parseLineBreak } from '../../../../shared/api/html/parseLineBreak.js';

/*  EXAMPLE stepData type distinct of bm

    {
    "date": "15/05/2023",
    "object": "{\"extension\":\"TXT\",\"data\":\"Q29uZGljaW9uZXMgZGUgdXNvIHkgY...SW50ZXJuZXQu\"}"
  }
*/
export function getContent(stepData) {
  const returnData = JSON.parse(stepData.object);

  let content = '';

  // tos
  if (returnData.extension?.toUpperCase() === 'PDF') {
    content += `<ewc-pdf-viewer print download fullscreen scale="1" pdf-name="serviceconditions.pdf" pdf64="${returnData.data}"></ewc-pdf-viewer>`;
  } else {
    content += `<div style="white-space:normal;font-family: monospace;">${parseLineBreak(decodeB64WithEncoding(returnData.data))}</div>`;
  }

  // agree
  content += `<ewc-checkbox name="checkMandatory"required label="${edicom.locale.translate('enrollment.bmcondicionesuso.label.agreement')}"></ewc-checkbox>`;

  return content;
}
